import { connect } from 'react-redux';
import {
  hardwareSelectors,
  setViewAllNetworksModal,
} from '../../../../../../redux/configuration/hardware/slice';
import { RootState } from '../../../../../../redux/store';
import { ViewAllNetworksModal } from '.';

const mapDispatchToProps = {
  setViewAllNetworksModal,
};

const mapStateToProps = (state: RootState) => ({
  viewAllNetworksModal: hardwareSelectors.getViewAllNetworksModal(state),
});

export type ViewAllNetworksModalProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

export const ViewAllNetworksModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ViewAllNetworksModal);
